/**
 * Quiz Results Page: A/B Testing Framework
 * Test variations, statistical significance, winner auto-promotion
 */

(function() {
  'use strict';

  // A/B Test Configuration
  const AB_TESTS = {
    headline: {
      variants: [
        { id: 'control', text: 'Your Perfect Sleep Ritual' },
        { id: 'variant_a', text: 'Your Personalized Sleep Solution' },
        { id: 'variant_b', text: 'Discover Your Ideal Sleep Protocol' }
      ],
      element: '.veluna-quiz-results-hero h1',
      metric: 'conversion_rate'
    },
    cta: {
      variants: [
        { id: 'control', text: 'Add to Cart', class: 'veluna-btn-primary' },
        { id: 'variant_a', text: 'Get My Ritual', class: 'veluna-btn-primary' },
        { id: 'variant_b', text: 'Start My Journey', class: 'veluna-btn-primary' }
      ],
      element: '[data-results-add-to-cart]',
      metric: 'click_rate'
    }
  };

  /**
   * Get or assign user to test variant
   */
  function getVariant(testName) {
    const storageKey = `veluna_ab_test_${testName}`;
    let variant = localStorage.getItem(storageKey);

    if (!variant) {
      // Assign variant (50/50 split for now, can be adjusted)
      const variants = AB_TESTS[testName].variants;
      const random = Math.random();
      const index = Math.floor(random * variants.length);
      variant = variants[index].id;
      localStorage.setItem(storageKey, variant);
    }

    return variant;
  }

  /**
   * Apply A/B test variant
   */
  function applyVariant(testName, variantId) {
    const test = AB_TESTS[testName];
    if (!test) return;

    const variant = test.variants.find(v => v.id === variantId);
    if (!variant) return;

    const element = document.querySelector(test.element);
    if (!element) return;

    if (testName === 'headline') {
      element.textContent = variant.text;
    } else if (testName === 'cta') {
      element.textContent = variant.text;
      if (variant.class) {
        element.className = element.className.replace(/veluna-btn-\w+/g, '') + ' ' + variant.class;
      }
    }

    // Track variant assignment
    if (window.VelunaQuizResultsCart && window.VelunaQuizResultsCart.trackEvent) {
      window.VelunaQuizResultsCart.trackEvent('ab_test_assigned', {
        test_name: testName,
        variant: variantId
      });
    }
  }

  /**
   * Track A/B test conversion
   */
  function trackConversion(testName, variantId, conversionType) {
    const storageKey = `veluna_ab_test_${testName}_conversions`;
    let conversions = JSON.parse(localStorage.getItem(storageKey) || '{}');

    if (!conversions[variantId]) {
      conversions[variantId] = { views: 0, conversions: 0 };
    }

    if (conversionType === 'view') {
      conversions[variantId].views++;
    } else if (conversionType === 'conversion') {
      conversions[variantId].conversions++;
    }

    localStorage.setItem(storageKey, JSON.stringify(conversions));

    // Calculate conversion rate
    const rate = conversions[variantId].conversions / conversions[variantId].views;
    
    // Track to analytics
    if (window.VelunaQuizResultsCart && window.VelunaQuizResultsCart.trackEvent) {
      window.VelunaQuizResultsCart.trackEvent('ab_test_conversion', {
        test_name: testName,
        variant: variantId,
        conversion_type: conversionType,
        conversion_rate: rate
      });
    }
  }

  /**
   * Check statistical significance
   */
  function checkSignificance(testName) {
    const storageKey = `veluna_ab_test_${testName}_conversions`;
    const conversions = JSON.parse(localStorage.getItem(storageKey) || '{}');
    
    // Simple significance check (would use proper statistical test in production)
    const variants = Object.keys(conversions);
    if (variants.length < 2) return null;

    const rates = variants.map(v => ({
      id: v,
      rate: conversions[v].conversions / conversions[v].views || 0,
      sample: conversions[v].views
    }));

    // Find winner (highest conversion rate with sufficient sample)
    const winner = rates.reduce((best, current) => {
      if (current.sample >= 100 && current.rate > (best.rate || 0)) {
        return current;
      }
      return best;
    }, { rate: 0 });

    if (winner.id && winner.sample >= 100) {
      return winner.id;
    }

    return null;
  }

  /**
   * Auto-promote winning variant
   */
  function promoteWinner(testName, variantId) {
    // Save winner to permanent storage
    localStorage.setItem(`veluna_ab_test_${testName}_winner`, variantId);
    
    // Apply to all future sessions
    const storageKey = `veluna_ab_test_${testName}`;
    localStorage.setItem(storageKey, variantId);

    console.log(`A/B Test Winner: ${testName} - ${variantId}`);
  }

  /**
   * Initialize A/B tests
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    function waitForContent() {
      const resultsContainer = document.querySelector('[data-quiz-results-optimal]');
      if (resultsContainer && resultsContainer.innerHTML.trim()) {
        // Run A/B tests
        Object.keys(AB_TESTS).forEach(testName => {
          // Check for existing winner
          const winner = localStorage.getItem(`veluna_ab_test_${testName}_winner`);
          const variantId = winner || getVariant(testName);
          
          applyVariant(testName, variantId);
          trackConversion(testName, variantId, 'view');

          // Check significance periodically
          const significant = checkSignificance(testName);
          if (significant && !winner) {
            promoteWinner(testName, significant);
          }
        });

        // Track conversions
        document.querySelectorAll('[data-results-add-to-cart]').forEach(btn => {
          btn.addEventListener('click', function() {
            Object.keys(AB_TESTS).forEach(testName => {
              const variantId = localStorage.getItem(`veluna_ab_test_${testName}`) || 'control';
              trackConversion(testName, variantId, 'conversion');
            });
          });
        });

        console.log('Quiz Results A/B Testing: Framework initialized');
      } else {
        setTimeout(waitForContent, 100);
      }
    }

    waitForContent();
  }

  init();

  // Export
  if (typeof window !== 'undefined') {
    window.VelunaQuizResultsABTesting = {
      getVariant,
      applyVariant,
      trackConversion,
      checkSignificance,
      promoteWinner
    };
  }
})();









